<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }} Template</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <p>{{ ta_revised.task_name }}</p>

  <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.task_description.label', 'Description') }}</h6>
  <p class="white-space-pre-wrap">{{ ta_revised.task_description }}</p>

  <ng-container *ngIf="ta_revised.work_procedure">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.work_procedure.label', 'Work Procedure') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.work_procedure }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.training_qualifications">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.training_qualifications.label', 'Training/Qualifications') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.training_qualifications }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.duties">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.duties.label', 'Duties') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.duties }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.certificates">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.certificates.label', 'Certificates of Competency') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.certificates }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.emergency_arrangements">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.emergency_arrangements.label', 'Emergency Procedures') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.emergency_arrangements }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.code_of_practice">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.code_of_practice.label', 'Code of Practice') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.code_of_practice }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.maintenance_checks">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.maintenance_checks.label', 'Maintenance Checks') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.maintenance_checks }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.safety_practices">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.safety_practices.label', 'Safety Practice') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.safety_practices }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.ppe_other">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.ppe_other.label', 'PPE Other') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.ppe_other }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.work_permits_other">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.work_permits_other.label', 'Work Permits Other') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.work_permits_other }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.tools_other">
    <h6>{{ utils.getLangTerm('ta-jsa-swms.fields.tools_other.label', 'Tools Other') }}</h6>
    <p class="white-space-pre-wrap">{{ ta_revised.tools_other }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised?.ppe && ta_revised.ppe.length">
    <h6>PPE</h6>
    <ul>
      <li *ngFor="let ppe of ta_revised.ppe">{{ppe.title}}</li>
    </ul>
  </ng-container>

  <ng-container *ngIf="ta_revised?.work_permits && ta_revised.work_permits.length">
    <h6>Work Permits</h6>
    <ul>
      <li *ngFor="let work_permit of ta_revised.work_permits">{{work_permit.title}}</li>
    </ul>
  </ng-container>

  <ng-container *ngIf="ta_revised.created_by_user">
    <h6>Created By</h6>
    <p>
      <a (click)="onUserPublicView(ta_revised.created_by_user.hash)"
        matTooltip="View User Public Profile">
        {{ ta_revised.created_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised.date_created">
    <h6>Created At</h6>
    <p>{{( ta_revised.date_created * 1000) | timezoneConvertMedium }}</p>
  </ng-container>

  <ng-container *ngIf="ta_revised.updated_by_user">
    <h6>Last Updated By</h6>
    <p>
      <a (click)="onUserPublicView(ta_revised.updated_by_user.hash)"
        matTooltip="View User Public Profile">
        {{ ta_revised.updated_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="ta_revised.date_modified">
    <h6>Last Updated At</h6>
    <p>{{ (ta_revised.date_modified * 1000) | timezoneConvertMedium }}</p>
  </ng-container>

</mat-dialog-content>
